import type { Tier2Factor } from '@/types/analytics';

// Static config: which factors explain each Tier 1 KPI.
// Keys in TIER2_MAPPINGS match exactly the flat keys in buildTier2DataMap()
// in AnalyticsDashboard — no dot-path traversal needed.
export const TIER2_MAPPINGS: Record<string, Tier2Factor[]> = {
  show_rate: [
    { key: 'call_quality.qualification_rate', label: 'Qualification Rate', format: 'percent', link: '/analytics/health?highlight=qualification_rate' },
    { key: 'stage_dropoffs.showed', label: 'Show Drop-off', format: 'percent', link: '/analytics/funnel?highlight=showed' },
  ],
  close_rate: [
    { key: 'call_quality.avg_duration_all', label: 'Avg Call Duration', format: 'minutes', link: '/analytics/health?highlight=avg_duration' },
    { key: 'call_quality.qualification_rate', label: 'Qualified Call Rate', format: 'percent', link: '/analytics/health?highlight=qualification_rate' },
    { key: 'deal_velocity.avg_days_lead_to_close', label: 'Deal Velocity', format: 'days', link: '/analytics/health?highlight=deal_velocity' },
  ],
  cpl: [
    { key: 'best_cpl', label: 'Best Campaign CPL', format: 'currency', link: '/analytics/campaigns?highlight=cpl' },
  ],
  speed_to_lead: [
    { key: 'time_to_first_call.median_minutes', label: 'Median Response', format: 'minutes', link: '/analytics/health?highlight=speed_to_lead' },
  ],
  stale_leads: [
    { key: 'stale_by_stage', label: 'By Stage', format: 'breakdown', link: '/analytics/health?highlight=stale_leads' },
  ],
  qualified_calls: [
    { key: 'call_quality.qualified_held_calls', label: 'Qualified Calls', format: 'count', link: '/analytics/health?highlight=qualification_rate' },
    { key: 'call_quality.total_held_calls', label: 'Total Held Calls', format: 'count', link: '/analytics/health?highlight=qualification_rate' },
  ],
  revenue: [
    { key: 'funnel_close_rate', label: 'Funnel Close Rate', format: 'percent', link: '/analytics/funnel?highlight=close_rate' },
  ],
};

interface KpiMeta {
  label: string;
  target: string;
  higherIsBetter: boolean;
}

export const KPI_META: Record<string, KpiMeta> = {
  show_rate:       { label: 'Show Rate',         target: 'Target: >75%',   higherIsBetter: true  },
  close_rate:      { label: 'Close Rate',         target: 'Target: >35%',   higherIsBetter: true  },
  cpl:             { label: 'Cost Per Lead',       target: 'Target: <$40',   higherIsBetter: false },
  speed_to_lead:   { label: 'Speed to Lead',       target: 'Target: <15 min', higherIsBetter: false },
  stale_leads:     { label: 'Stale Leads',         target: 'Target: 0',      higherIsBetter: false },
  qualified_calls: { label: 'Qualified Call Rate', target: 'Target: >75%',   higherIsBetter: true  },
  revenue:         { label: 'Revenue',             target: '',               higherIsBetter: true  },
};
